import { useEffect, useRef } from 'react'

/** Keep keyboard focus inside the existing add/edit forms and restore the opener. */
export function usePartyDialogFocus(title: string) {
  const opener = useRef(document.activeElement as HTMLElement | null)
  useEffect(() => {
    const dialog = document.querySelector<HTMLElement>(
      `[role="dialog"][aria-label="${title}"]`,
    )
    const prior = opener.current
    const selector =
      'button:not(:disabled), input:not(:disabled), textarea, select, a[href]'
    dialog?.querySelector<HTMLElement>(selector)?.focus()
    const trap = (event: KeyboardEvent) => {
      if (event.key !== 'Tab') return
      const items = Array.from(
        dialog?.querySelectorAll<HTMLElement>(selector) ?? [],
      )
      const first = items[0],
        last = items[items.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last?.focus()
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first?.focus()
      }
    }
    dialog?.addEventListener('keydown', trap)
    return () => {
      dialog?.removeEventListener('keydown', trap)
      if (prior?.isConnected) prior.focus()
      else
        document
          .querySelector<HTMLButtonElement>('[aria-label="Contact actions"]')
          ?.focus()
    }
  }, [title])
}
